export default __webpack_public_path__ + "static/media/019-poison.22e8f492.svg";